export const newTabs = ['InsightExplorerApp'];
